@for (row of rows(); track row.id; let i = $index) {
  <div
    company-tree-row
    [row]="row"
    (selectCompany)="onSelect($event)"
    (toggleExpand)="onToggle($event)"
    (retry)="onRetry($event)"
  ></div>
  @for (parentId of sentinelParentIds(i); track parentId) {
    <div
      class="company-tree__sentinel"
      role="none"
      aria-hidden="true"
      [loadMoreSentinel]="scrollRoot()"
      (loadMore)="onLoadMore(parentId)"
    ></div>
  }
  <!-- Strictly after the sentinels: a block above one would displace it in the
       scroll flow and paging would stop. -->
  @if (showLoadingMoreAfter(i)) {
    <div class="company-tree__loading-more" role="none" aria-hidden="true">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }
}
